import { Box, Button, Flex, Icon, Image, Text, VStack } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { IconType } from "react-icons";
import img1 from "../assets/DSC04094_j5uf3u.webp";
import img4 from "../assets/R6_7647.jpg";
import img2 from "../assets/R6_7683.jpg";
import img3 from "../assets/R6_7744.jpg";

const MotionVStack = motion(VStack);

const products = [
  {
    id: 2,
    image: img2,
    alt: "Produto Sedapé 2",
  },
  {
    id: 3,
    image: img3,
    alt: "Produto Sedapé 3",
  },
  {
    id: 4,
    image: img4,
    alt: "Produto Sedapé 4",
  },
  {
    id: 1,
    image: img1,
    alt: "Produto Sedapé 1",
  },
];

export default function Products() {
  const whatsappLink = "https://wa.me/44991131379";

  const ChakraIcon = (icon: IconType) => icon as unknown as React.ElementType;

  return (
    <MotionVStack
      spacing={12}
      px={{ base: 6, md: 20 }}
      py={{ base: 16, md: 24 }}
      bg="white"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, type: "spring", stiffness: 60 }}
    >
      {/* Título */}
      <VStack spacing={2} textAlign="center">
        <Text
          fontSize={{ base: "sm", md: "md" }}
          color="sedapePink"
          fontWeight="600"
          letterSpacing="widest"
        >
          NOSSOS PRODUTOS
        </Text>
        <Text
          fontSize={{ base: "2xl", md: "3xl" }}
          fontWeight="bold"
          color="sedapePinkDark"
          fontFamily="heading"
        >
          Explore Nossa Coleção
        </Text>
      </VStack>

      {/* Carrossel */}
      <Box w="100%" maxW="1200px">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          }}
          className="swiper-products"
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              <Box
                borderRadius="xl"
                overflow="hidden"
                bg="gray.50"
                boxShadow="md"
                transition="all 0.3s ease"
                _hover={{
                  boxShadow: "lg",
                  transform: "translateY(-4px)",
                }}
              >
                {/* Imagem do Produto */}
                <Box
                  position="relative"
                  overflow="hidden"
                  h={{ base: "550px", md: "550px" }}
                  bg="gray.100"
                >
                  <Image
                    src={product.image}
                    loading="lazy"
                    alt={product.alt}
                    w="100%"
                    h="100%"
                    objectFit="cover"
                    objectPosition="center"
                    transition="transform 0.3s ease"
                    _hover={{ transform: "scale(1.05)" }}
                  />
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* CTAs - Botões Únicos */}
      <Flex
        gap={{ base: 4, md: 6 }}
        w="100%"
        maxW="500px"
        justify="center"
        direction={{ base: "column", sm: "row" }}
      >
        <Button
        onClick={() => window.open(whatsappLink, "_blank")}
        flex={1}
        bg="green.500"
        color="white"
        fontWeight="600"
        py="6"
        borderRadius="lg"
        fontSize={{ base: "sm", md: "md" }}
        leftIcon={<Icon as={ChakraIcon(FaWhatsapp)} />}
        transition="all 0.3s ease"
        _hover={{
            bg: "green.600",
            transform: "scale(1.05)",
        }}
        _active={{
            transform: "scale(0.98)",
        }}
        >
            Fale Conosco
        </Button>
      </Flex>

      {/* Estilos do Swiper */}
      <style>{`
        .swiper-products {
          padding: 20px 0 !important;
        }

        .swiper-button-next,
        .swiper-button-prev {
          color: #FE3265;
          background-color: rgba(254, 50, 101, 0.1);
          width: 44px;
          height: 44px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          top: 50%;
          transform: translateY(-50%);
        }

        .swiper-button-next::after,
        .swiper-button-prev::after {
          font-size: 20px;
        }

        .swiper-button-next:hover,
        .swiper-button-prev:hover {
          background-color: rgba(254, 50, 101, 0.2);
          color: #E50F66;
        }

        .swiper-pagination-bullet {
          background-color: #FE3265 !important;
          opacity: 0.3;
        }

        .swiper-pagination-bullet-active {
          background-color: #FE3265 !important;
          opacity: 1;
        }

        @media (max-width: 768px) {
          .swiper-button-next,
          .swiper-button-prev {
            width: 36px;
            height: 36px;
          }

          .swiper-button-next::after,
          .swiper-button-prev::after {
            font-size: 16px;
          }
        }
      `}</style>
    </MotionVStack>
  );
}
